import React, { useContext, useEffect, useRef, useState } from "react";
import classNames from "classnames";

import {
  Button,
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Input,
  NavbarBrand,
  Navbar,
  NavLink,
  Nav,
  Container,
  Modal,
  UncontrolledTooltip,
} from "reactstrap";
import { useLogout } from "utils/logout";
import { Link, useNavigate } from "react-router-dom";
import PATHS from "constant/paths";
import { UserContextProvider } from "context/UserContext";
import { Notification } from "network/EndPoints";
import { GetAdminNotifications } from "network/wineDataSetAPI";
import { ErrorToaster } from "components/common/toast";
import handleError from "utils/handleError";
import { ReadNotificationAPI } from "network/wineDataSetAPI";
import { infoToaster } from "components/common/toast";
import { useTranslation } from "react-i18next";
import i18n from "i18n";
import LanguageSwitch from "components/common/LanguageSwitch";

const AdminNavbar = (props) => {
  const { t } = useTranslation("nav");
  const { user, setNotifications, notifications } =
    useContext(UserContextProvider);
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  const [modalSearch, setModalSearch] = React.useState(false);
  const [color, setColor] = React.useState("navbar-transparent");
  const navigate = useNavigate();

  const logout = useLogout();
  React.useEffect(() => {
    window.addEventListener("resize", updateColor);
    return function cleanup() {
      window.removeEventListener("resize", updateColor);
    };
  });

  const updateColor = () => {
    if (window.innerWidth < 993 && collapseOpen) {
      setColor("bg-white");
    } else {
      setColor("navbar-transparent");
    }
  };
  const toggleCollapse = () => {
    if (collapseOpen) {
      setColor("navbar-transparent");
    } else {
      setColor("bg-white");
    }
    setCollapseOpen(!collapseOpen);
  };
  const toggleModalSearch = () => {
    setModalSearch(!modalSearch);
  };
  useEffect(() => {
    if (
      user?.role?.toLowerCase() !== "admin" &&
      user?.role?.toLowerCase() !== "super_admin"
    )
      return;

    const eventSource = new EventSource(
      `${process.env.REACT_APP_BASE_URL}${Notification?.ADMIN_NOTIFICATION_EVENTS}`
    );

    eventSource.onmessage = (event) => {
      try {
        const outer = JSON.parse(event.data);
        const data = JSON.parse(outer.data);
        // setNotifications((prev) => ({
        //   ...prev,
        //   items: [data, ...(prev.items || [])],
        //   count: data?.product_count ?? prev.count,
        // }));
        GetNotificationList();
        infoToaster(
          i18n.t("nav:navbar.newNotification", {
            user: data.user_name,
            product: data.product_name,
          })
        );
      } catch (error) {
        console.error("Failed to parse SSE data:", error);
      }
    };

    eventSource.onerror = (error) => {
      eventSource.close();
    };

    return () => {
      eventSource.close();
    };
  }, [user]);
  const GetNotificationList = async () => {
    try {
      const response = await GetAdminNotifications();
      if (response.success) {
        setNotifications({
          items: response?.notifications?.items || [],
          count: response?.notifications?.notification_count || 0,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (
      user?.role?.toLowerCase() !== "admin" &&
      user?.role?.toLowerCase() !== "super_admin"
    )
      return;

    GetNotificationList();
  }, [user]);

  const ReadNotification = async (id) => {
    try {
      const response = await ReadNotificationAPI(id);
      if (response.success) {
        GetNotificationList();
        // setNotifications((prev) => ({
        //   ...prev,
        //   items: prev.items.filter(
        //     (item) => item.WINE_DATASET_UNAPPROVED_LIST !== id
        //   ),
        //   count: Math.max(prev.count - 1, 0),
        // }));
        navigate(`${PATHS.WINE_DATASET_UNAPPROVED_VIEW}/${id}`);
      }
    } catch (error) {
      ErrorToaster(handleError(error?.status_code, error?.message));
    }
  };

  return (
    <>
      <Navbar
        className={classNames("fixed-top", {
          [color]: props.location?.pathname?.indexOf("full-screen-map") === -1,
        })}
        expand="lg"
      >
        <Container fluid>
          <div className="navbar-wrapper">
            <div className="navbar-minimize d-inline">
              <Button
                className="minimize-sidebar btn-just-icon"
                color="link"
                id="tooltip209599"
                onClick={props.handleMiniClick}
              >
                <i className="tim-icons icon-align-center visible-on-sidebar-regular" />
                <i className="tim-icons icon-bullet-list-67 visible-on-sidebar-mini" />
              </Button>
              <UncontrolledTooltip
                delay={0}
                target="tooltip209599"
                placement="right"
              >
                {t("navbar.sidebarToggle")}
              </UncontrolledTooltip>
            </div>
            <div
              className={classNames("navbar-toggle d-inline", {
                toggled: props.sidebarOpened,
              })}
            >
              <button
                className="navbar-toggler"
                type="button"
                onClick={props.toggleSidebar}
              >
                <span className="navbar-toggler-bar bar1" />
                <span className="navbar-toggler-bar bar2" />
                <span className="navbar-toggler-bar bar3" />
              </button>
            </div>
            <NavbarBrand href="#pablo" onClick={(e) => e.preventDefault()}>
              {props.brandText}
            </NavbarBrand>
          </div>
          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navigation"
            aria-expanded="false"
            aria-label={t("navbar.toggleNavigation")}
            onClick={toggleCollapse}
          >
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
            <span className="navbar-toggler-bar navbar-kebab" />
          </button>
          <Collapse navbar isOpen={collapseOpen}>
            <Nav className="ml-auto align-items-center" navbar>
              <li className="nav-item d-flex align-items-center">
                <LanguageSwitch />
              </li>
              {/* <InputGroup className="search-bar" tag="li">
                <Button
                  color="link"
                  data-target="#searchModal"
                  data-toggle="modal"
                  id="search-button"
                  onClick={toggleModalSearch}
                >
                  <i className="tim-icons icon-zoom-split" />
                  <span className="d-lg-none d-md-block">Search</span>
                </Button>
              </InputGroup> */}
              {(user?.role?.toLowerCase() === "admin" ||
                user?.role?.toLowerCase() === "super_admin") && (
                <UncontrolledDropdown nav>
                  <DropdownToggle
                    caret
                    color="default"
                    data-toggle="dropdown"
                    nav
                  >
                    {notifications.count > 0 && (
                      <div className="notification">{notifications.count}</div>
                    )}
                    <i className="tim-icons icon-bell-55" />
                    <p className="d-lg-none">{t("navbar.notifications")}</p>
                  </DropdownToggle>
                  {notifications.items?.length > 0 ? (
                    <DropdownMenu className="dropdown-navbar" right tag="ul">
                      {notifications.items.map((notification) => (
                        <NavLink
                          tag="li"
                          key={notification.id}
                          onClick={() =>
                            ReadNotification(
                              notification?.wine_dataset_request_uuid
                            )
                          }
                        >
                          <DropdownItem className="nav-item">
                            {notification.product_name} (
                            {notification.user_name})
                          </DropdownItem>
                        </NavLink>
                      ))}
                      {notifications.count > 5 && (
                        <NavLink tag="li">
                          <DropdownItem
                            className="nav-item text-center text-primary font-weight-bold"
                            onClick={() =>
                              navigate(PATHS.WINE_DATASET_UNAPPROVED_LIST)
                            }
                          >
                            {t("navbar.readMore")}
                          </DropdownItem>
                        </NavLink>
                      )}
                    </DropdownMenu>
                  ) : (
                    <DropdownMenu className="dropdown-navbar" right tag="ul">
                      <NavLink tag="li">
                        <DropdownItem className="nav-item">
                          {t("navbar.noNotifications")}
                        </DropdownItem>
                      </NavLink>
                    </DropdownMenu>
                  )}
                </UncontrolledDropdown>
              )}
              <UncontrolledDropdown nav>
                <DropdownToggle
                  caret
                  color="default"
                  data-toggle="dropdown"
                  nav
                  onClick={(e) => e.preventDefault()}
                >
                  <div className="photo">
                    <img
                      alt={t("navbar.profile")}
                      src={
                        user?.profile_url
                          ? `${process.env.REACT_APP_BASE_URL}${user.profile_url}`
                          : require("assets/img/user_img.png")
                      }
                    />
                  </div>
                  <b className="caret d-none d-lg-block d-xl-block" />
                  <p className="d-lg-none" onClick={logout}>
                    {t("navbar.logout")}
                  </p>
                </DropdownToggle>
                <DropdownMenu className="dropdown-navbar" right tag="ul">
                  <NavLink tag="li">
                    <Link to={PATHS.ACCOUNT}>
                      <DropdownItem className="nav-item">{t("navbar.account")}</DropdownItem>
                    </Link>
                  </NavLink>
                  {user?.role?.toLowerCase() === "super_admin" && (
                    <NavLink tag="li">
                      <Link to={PATHS.SETTING}>
                        <DropdownItem className="nav-item">
                          {t("navbar.settings")}
                        </DropdownItem>
                      </Link>
                    </NavLink>
                  )}

                  <DropdownItem divider tag="li" />
                  <NavLink tag="li">
                    <DropdownItem className="nav-item" onClick={logout}>
                      {t("navbar.logout")}
                    </DropdownItem>
                  </NavLink>
                </DropdownMenu>
              </UncontrolledDropdown>
              <li className="separator d-lg-none" />
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
      <Modal
        modalClassName="modal-search"
        isOpen={modalSearch}
        toggle={toggleModalSearch}
      >
        <div className="modal-header">
          <Input id="inlineFormInputGroup" placeholder={t("navbar.search")} type="text" />
          <button
            aria-label={t("navbar.close")}
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={toggleModalSearch}
          >
            <i className="tim-icons icon-simple-remove" />
          </button>
        </div>
      </Modal>
    </>
  );
};

export default AdminNavbar;
